var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-center wrapper"},[_c('h1',{staticClass:"padding align-self-center"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("botoes")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }